import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ErrorInAPIComp = ({ onRetry }: { onRetry?: () => void }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="200px"
            width="100%"
        >
            <ErrorOutlineIcon style={{ fontSize: 24, color: '#7A7A7A', marginBottom: 12 }} />
            <Typography variant="body1" color="textSecondary" style={{ marginBottom: 8 }}>
                Could not load chat filters
            </Typography>
            <Button
                variant="text"
                color="primary"
                onClick={onRetry}
                style={{ textTransform: 'none', fontWeight: 500 }}
            >
                Retry
            </Button>
        </Box>
    );
};

export default ErrorInAPIComp;